import { ActionType } from '../../../stores/action-types';
import Button from '@material-ui/core/Button';
import Card from '../../../../components/Card/CardTS';
import CardBody from '../../../../components/Card/CardBody.js';
import CardHeader from '../../../../components/Card/CardHeader.js';
import CardIcon from '../../../../components/Card/CardIcon.js';
import React, { useCallback } from 'react';
import regularFormsStyle from '../../../../assets/jss/material-dashboard-pro-react/views/regularFormsStyleTS';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import { exportMeasurements } from  '../../../stores/actions/exportActions';
import { connect } from 'react-redux';
import Snackbar from '../../../../components/Snackbar/Snackbar';
import Node from '@material-ui/icons/Memory';
import utils from '../../../helpers/GlobalVariables';
import { Account, ISystem } from '../../../helpers/interfaces';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import DoneAll from '@material-ui/icons/DoneAll';
import { InputAdornment, IconButton, Grid } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

import _ from 'lodash';

import './Export.css';

interface IExportmeasurementsProps {
    account: Account;
    classes: ClassNameMap;
    exportFailed: boolean;
    exportFailedNoData: boolean;
    mobileView: boolean;
    isFileExporting: boolean;
    exportMeasurements: (sysID, sysName, allNodes, dateStart, dateEnd) => void;
    systems: ISystem[];
    systemsNodesShort: any[];
}

const Exportmeasurements = ({
    exportFailed,
    exportFailedNoData,
    mobileView,
    exportMeasurements,
    systems,
    account,
    isFileExporting,
    systemsNodesShort,
    ...props
}: IExportmeasurementsProps) => {
    const { classes } = props;
    const [pickedSystem, setPickedSystem] = useState<number|null|undefined>(null);
    const [allNodes, setAllNodes] = useState(false);
    const [systemNodesIds, setSystemNodesIds] = useState([]);
    const [systemNodesNamesByIds, setSystemNodesNamesByIds] = useState([]);
    const [pickedNodes, setPickedNodes] = useState([]);
    const allNodesSelected = pickedNodes.length === systemNodesIds.length;

    let today = new Date();
    let yearAgo = new Date(new Date(today).setFullYear(today.getFullYear() - 1));

    const [date, setDate] = useState([yearAgo, today]);
    const [dateError, setDateError] = useState(false);

    const dispatch = useDispatch();
    const closeNotificationTimer = useRef(null);
    const systemIds = systems.map(el => el.ID);
    const systemNamesByIds = Object.fromEntries(systems.map(x => [x.ID, x.name]));

    const closeExportNotification = useCallback(() => {
        dispatch({ type: ActionType.CLOSE_EXPORT_NOTIFICATION });
    }, [dispatch]);

    useEffect(() => {
        if (exportFailed || isFileExporting || exportFailedNoData) {
            closeNotificationTimer.current = setTimeout(closeExportNotification, 6000);
        }
        return () => {
            clearTimeout(closeNotificationTimer.current);
        };
    }, [closeExportNotification, exportFailed, isFileExporting, exportFailedNoData]);

    useEffect(() => {
        setDateError(!date || !date[0] || !date[1])
    }, [date]);

    useEffect(() => {
        let nodes = [];
        let nodesIds = [];
        let nodesNamesByIds = [];
        if (pickedSystem) {
            nodes = _.filter(systemsNodesShort, { systemId: pickedSystem });
            nodesIds = nodes.map(el => el.nodeId);
            nodesNamesByIds = Object.fromEntries(nodes.map(x => [x.nodeId, x.nodeName]));
        }
        setSystemNodesIds(nodesIds);
        setSystemNodesNamesByIds(nodesNamesByIds);
        setPickedNodes([]);
    }, [pickedSystem]);

    const exportButton = (): JSX.Element => {
        return (
            <Button
                size='medium'
                style={{ marginTop: exportFailed ? '5px' : '25px', transition: 'color 0.3s' }}
                disabled={!pickedSystem || dateError}
                onClick={() => { exportMeasurements(pickedSystem, pickedSystem ? systemNamesByIds[pickedSystem] : 'All', pickedNodes, date[0], date[1]) }}
            >
                Export
            </Button>
        );
    };

    const renderMobileNotifications = (): JSX.Element => {
        const headerStyle = utils.getHeaderStyle(exportFailed || exportFailedNoData);

        if (!mobileView) return null;
        if (exportFailed || isFileExporting || exportFailedNoData) {
            const className = exportFailed || exportFailedNoData ? 'notification-open-create-account-fail' : 'notification-open-create-account-success';
            return (
                <h5 className={className} style={headerStyle}>
                    {exportFailed
                        ? "Export failed."
                        : ( exportFailedNoData ? 'Nothing to export' : 'Export will begin shortly.')}
                </h5>
            );
        }
        return <div style={utils.emptyHeaderStyle}></div>;
    };

    const handleSelectAll = () => {
        if (pickedSystem) {
            const nodes = _.filter(systemsNodesShort, { systemId: pickedSystem });
            const nodesIds = nodes.map(el => el.nodeId);
            setPickedNodes(nodesIds);
        }
    }

    const handleDateRangePickerRender = () => {
        return (
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <KeyboardDatePicker
                            margin="normal"
                            label="Start Date"
                            format="yyyy-MM-dd"
                            value={date[0]}
                            onChange={(d) => setDate([d, date[1]])}
                            minDate={new Date('2010-01-01')}
                            maxDate={new Date()}
                            disableFuture
                            autoOk
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <KeyboardDatePicker
                            margin="normal"
                            label="End Date"
                            format="yyyy-MM-dd"
                            value={date[1]}
                            onChange={(d) => setDate([date[0], d])}
                            minDate={new Date('2010-01-01')}
                            maxDate={new Date()}
                            disableFuture
                            autoOk
                            fullWidth
                        />
                    </Grid>
                </Grid>
            </MuiPickersUtilsProvider>
        );
    }
    return (
        <Card className='exportmeasurementsForm'>
            <CardHeader color='info' icon>
                <CardIcon color='info'>
                    <Node />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>Export Measurements</h4>
            </CardHeader>
            <CardBody>
                <FormControl fullWidth className={classes.selectFormControl} onSubmit={(e) => e.preventDefault()} disabled={!systems || !systems.length}>
                    <div style={{ width: '100%' }}>
                        <Autocomplete
                            options={systemIds}
                            getOptionLabel={(id) => systemNamesByIds[id]}
                            id='system-name'
                            value={pickedSystem}
                            onChange={(e, newVal) => setPickedSystem(newVal)}
                            renderInput={(params) => <TextField {...params} label='System' margin='normal' />}
                            style={{ width: '100%' }}
                        />
                        <Autocomplete
                            options={systemNodesIds}
                            multiple
                            disableCloseOnSelect
                            value={pickedNodes}
                            onChange={(e, newVal) => setPickedNodes(newVal)}
                            getOptionLabel={(id) => systemNodesNamesByIds[id]}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Nodes"
                                    margin="normal"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                <InputAdornment>
                                                    {!allNodesSelected && (
                                                        <IconButton onClick={handleSelectAll} size="small" title={'Select all'}>
                                                            <DoneAll color={'primary'} />
                                                        </IconButton>
                                                    )}
                                                </InputAdornment>
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />
                            )}
                            style={{ width: '100%' }}
                        />
                    </div>
                    <div>
                        {handleDateRangePickerRender()}
                    </div>
                </FormControl>
                {renderMobileNotifications()}
                {exportButton()}
            </CardBody>
            {!mobileView && (
                <Snackbar
                    close
                    closeNotification={() => closeExportNotification()}
                    color={exportFailed || exportFailedNoData ? 'danger' : 'success'}
                    message={exportFailed ? 'Export failed.' : ( exportFailedNoData ? 'Nothing to export' : 'Export will begin shortly.')}
                    open={exportFailed || isFileExporting || exportFailedNoData}
                    place='tc'
                />
            )}
        </Card>
    );
};

const mapStateToProps = (state) => ({
    exportFailed: state.dashboard.exportFailed,
    exportFailedNoData: state.dashboard.exportFailedNoData,
    isFileExporting: state.dashboard.isFileExporting,
    mobileView: state.dashboard.mobileView
});
const actions = {
    exportMeasurements,
};

const ExportmeasurementsWithStyles = regularFormsStyle(Exportmeasurements);
export default connect(mapStateToProps, actions)(ExportmeasurementsWithStyles);
